<template>
  <div class="Holdings">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- v-loading="loading" -->
        <el-card class="box-card" v-loading="loading">
          <div class="
              flex-space-between
              label-md-bold-black
              stock-ranking
              capitalize
            ">
            <div class="flex">
              <img src="../assets/images/rank0.png" style="height: 18px; margin-right: 10px" />
              Holdings
              <span v-if="holdings.length">({{ holdings.length }})</span>
            </div>
            <div class="flex">
              <el-input v-model="search" size="mini" suffix-icon="el-icon-search" placeholder="Search"
                style="width: 210px"></el-input>
              <i class="el-icon-refresh left-margin-10" @click="getHoldingsNetWorkCallBack()"></i>
            </div>
          </div>
          <div class="left-margin-5 label-xsss-black-bold flex-end"
            v-if="userProfile && userProfile.utm_source == 'Bigul'">
            <p>Note: Once T-Pin Verified click on refresh button for sell</p>
          </div>

          <table class="holdings-description-table top-margin-15">
            <thead>
              <tr>
                <th style="text-align: left;">Name</th>
                <th v-if="userProfile &&
                  userProfile.utm_source != 'Bigul' &&
                  userProfile.utm_source != 'Paytm Money' &&
                  userProfile.utm_source != 'Choice' &&
                  userProfile.utm_source != 'Tradeplus' &&
                  userProfile.utm_source != 'Nirman' &&
                  userProfile.utm_source != 'Basan' &&
                  userProfile.utm_source != 'Rupeezy' &&
                  userProfile.utm_source != 'Almondz Trade' &&
                  userProfile.utm_source != 'Maitra Commodities'
                  ">
                  Product
                </th>
                <th>Qty</th>
                <th>Avg. Cost</th>
                <th v-if="userProfile &&
                  (userProfile.utm_source == 'Bigul' ||
                    userProfile.utm_source == 'Nirman' ||
                    userProfile.utm_source == 'Tradeplus')
                  ">
                  Action
                </th>
                <!-- <th>LTP</th> -->
                <!-- <th>&nbsp;</th> -->
                <!-- <th>Cur. Val</th> -->
                <!-- <th>P&L</th> -->
                <!-- <th>Net Chg.</th> -->
                <!-- <th>Day Chg.</th> -->
              </tr>
            </thead>

            <tbody v-if="holdings.length">
              <tr v-for="(item, item_index) in getHoldings.filter(
                (data) =>
                  !search ||
                  data.symbol.toLowerCase().includes(search.toLowerCase())
              )" :key="item_index">
                <td style="text-align: left;">{{ item.symbol }}</td>
                <td v-if="userProfile &&
                  userProfile.utm_source != 'Bigul' &&
                  userProfile.utm_source != 'Paytm Money' &&
                  userProfile.utm_source != 'Choice' &&
                  userProfile.utm_source != 'Tradeplus' &&
                  userProfile.utm_source != 'Nirman' &&
                  userProfile.utm_source != 'Basan' &&
                  userProfile.utm_source != 'Rupeezy' &&
                  userProfile.utm_source != 'Almondz Trade' &&
                  userProfile.utm_source != 'Maitra Commodities'
                  ">
                  {{
                    item.product == "CNC" ||
                    item.product == "C"
                    ? "Delivery"
                    : item.product == "MIS" ||
                      item.product == "I"
                      ? "Intraday"
                      : item.product == "B"
                        ? "Bracket Order"
                        : item.product == "NRML"
                          ? "Normal"
                          : item.product
                  }}
                </td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.average_price }}</td>
                <td>
                  <div v-if="userProfile && userProfile.utm_source == 'Bigul'">
                    <el-button class="btn-secondary-theme-borderd" size="mini" @click="getUserDetails()"
                      v-if="item.authorize_quantity == 0">
                      Sell</el-button>
                    <el-button class="btn-secondary-theme-borderd" size="mini" @click="sellStock(item)" v-else>
                      Sell</el-button>
                  </div>
                  <div v-if="userProfile &&
                    (userProfile.utm_source == 'Nirman' ||
                      userProfile.utm_source == 'Tradeplus')
                    ">
                    <el-button class="btn-secondary-theme-borderd" size="mini" @click="sellStock(item)">
                      Sell</el-button>
                  </div>

                  <div v-if="userProfile && userProfile.utm_source == 'Choice'">
                    <el-button class="btn-secondary-theme-borderd" size="mini" @click="sellStockChoice(item)">
                      Sell</el-button>
                  </div>
                  <div v-if="userProfile && userProfile.utm_source == 'Paytm Money'
                    ">
                    <el-button class="btn-secondary-theme-borderd" size="mini" @click="generateTpinForPaytm(item)">
                      Sell</el-button>
                  </div>
                </td>
                <!-- <td>{{ item.ltp ? item.ltp : 'NA' }}</td> -->
                <!-- <td>{{ item.cur_val }}</td> -->
                <!-- <td :style="[item.p_l > 0 ? { color: '#079e3e' } : item.p_l < 0 ? { color: '#d60918' } : {}]">{{ item.p_l }}</td> -->
                <!-- <td :style="[item.net_chg > 0 ? { color: '#079e3e' } : item.net_chg < 0 ? { color: '#d60918' } : {}]">{{ item.net_chg }}%</td> -->
                <!-- <td :style="[item.day_chg > 0 ? { color: '#079e3e' } : item.day_chg < 0 ? { color: '#d60918' } : {}]">{{ item.day_chg }}%</td> -->
                <!-- <td>
                                    <el-button class="btn-secondary-theme-borderd" size="mini" @click="sendTPIN(item)">SELL</el-button>
                                </td> -->
              </tr>
            </tbody>
          </table>

          <NoDataFound v-if="!holdings.length" style="padding: 0"></NoDataFound>

          <!-- <div style="border-bottom: 1px solid #ddd; padding-bottom: 15px;">
                        <div class="font-1rem font-weight-500">Hi, {{ userProfile.first_name }}</div>
                    </div>

                    <div class="top-margin-25">
                        <div class="flex font-09rem font-weight-500">
                            <i class="el-icon-pie-chart"></i> <div class="left-margin-10">Equity</div>
                        </div>
                    </div>

                    <div class="top-margin-15">
                        <div class="flex">
                            <div style="width: 33.33%; border-right: 1px solid #ddd;">
                                <div style="font-size: 2rem; font-weight: 300; line-height: 1.5;">0</div>

                                <div class="sub-title">Margin available</div>
                            </div>

                            <div style="margin-left: 40px;">
                                <div>
                                    <span class="sub-title">Margin used</span>&nbsp;<span class="font-08rem">0</span>
                                </div>

                                <div class="top-margin-15">
                                    <span class="sub-title">Opening balance</span>&nbsp;<span class="font-08rem">0</span>
               generateTpinForPaytm(stock) {
      console.log(stock);
      serverAddr
        .post("/trade/v1/generate_tpin_form", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
          trade_type: stock.exchange,
          isin_list: [
            {
              isin: "INE413X01027",
              qty: stock.net_quantity,
            },
          ],
        })
        .then((response) => {
          if (response.data.status) {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openPaytmSite() {
      let apiUrl = "https://eDIS.cdslindia.com/eDIS/VerifyDIS";
      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", apiUrl);
      // form.setAttribute("target", "_blank");

      let params = {
        DPId: "88800",
        ReqId: "20478646",
        Version: "1.2",
        TransDtls:
          "zUi1cFSMvnMUG2qaHkvfSpWOAvBb+61ioARzb3igCQ+g8PTHD65VaTqwGgao6kPP+hqFAsXq9WYt/fG7GMpneRWjP8GjinC5ywNKcx+aNU9SR9BHrhySaIwEYqk5ExSHVvHozXvqDL8TsXA+g9gd6tNaKlS5/7DbmBbxlvkCeVU08RyWCXF7KZFOu8finlZkzrHLYeMpTi8dxUFpylK3qWkSnUM6cTWdAsecyv1HqjKR2dU1bnfT9pRLF1yv9MsJhNWKMkOyj3jQmZf2bJfJj/a8Cf140xRx4mUxYQ3qs4ZfkrKlzy4c6E1qZ83+dwOC1Ign6cH0lK6mSuGIR4bJkfqW3fY7fmsB+YhV+Zmb0Ec9zTcuBlt8YMnFbKYVrDcpBmmqw0sQl3lclW113wbzsSMlzwMwdH4XgH+snyNXC/pQljq/We0CF0EOPl8ugUFaGY00huvL4fsRnX4oPbzjHQ==",
      };

      for (var p in params) {
        let input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", p);
        input.setAttribute("value", params[p]);
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },                  </div>

                                <div class="top-margin-15 font-07rem">
                                    <span class="external-link-color font-weight-500 cursor-pointer">View statement</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="get_tpin_dialog_visibility" :close-on-click-modal="false" :close-on-press-escape="true"
      :lock-scroll="true" width="40%" :before-close="closeTpinDialog">
      <div id="bind-html">
        <div class="text-center font-08rem font-weight-500 primary-theme-color">
          Redirecting...
        </div>

        <div v-html="raw_html"></div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="sell_holding_dialog_visibility" :close-on-click-modal="false" :close-on-press-escape="true"
      :lock-scroll="true" width="40%">
      <!-- :before-close="closeTpinDialog" -->
      <div id="bind-html">
        <div class="
            text-center
            font-08rem font-weight-500
            primary-theme-color
            bottom-margin-20
          ">
          Redirecting...
        </div>

        <div>
          <form id="bigulForm" action="https://trading.bigul.co/clientEdis/" method="post" target="_blank">
            <div style="display: none !important">
              <input type="text" name="accountID" :value="fetchUserDetails.user_id" />

              <input type="text" name="boid" :value="fetchUserDetails.boid" />

              <input type="text" name="token" :value="fetchUserDetails.access_token" />

              <input type="text" name="userID" :value="fetchUserDetails.user_id" />
            </div>

            <a target="_blank" class="flex-center">
              <button class="btn-gradient top-margin-10 proceedBtn" size="mini" id="DetailSubmit"
                @click="sell_holding_dialog_visibility = false">
                Next
              </button>
            </a>
            <!-- <button id="DetailSubmit" >submit</button> -->
          </form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import NoDataFound from "@/components/NoDataFound.vue";

export default {
  name: "Holdings",

  components: {
    NoDataFound,
  },

  data() {
    return {
      search: "",
      holdings: [],
      loading: false,
      get_tpin_dialog_visibility: false,
      sell_holding_dialog_visibility: false,
      raw_html: {},
      fetchUserDetails: {},
    };
  },

  mounted() {
    if (localStorage.getItem("selected_broker")) {
      // call First when page render then it will be continuously call in loop after 15 sec
      this.getHoldingsNetWorkCallBack();

      if (localStorage.getItem("selected_broker") == 10) {
        // this.generateTpinForPaytm();
      }
      // this.getLatestHoldingStatus();
    }
  },

  methods: {
    generateTpinForPaytm(stock) {
      serverAddr
        .post("/trade/v1/generate_tpin_form", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
          trade_type: stock.exchange,
          isin_list: [
            {
              isin: "INE413X01027",
              qty: stock.net_quantity,
            },
          ],
        })
        .then((response) => {
          if (response.data.status) {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openPaytmSite() {
      let apiUrl = "https://eDIS.cdslindia.com/eDIS/VerifyDIS";
      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", apiUrl);
      // form.setAttribute("target", "_blank");

      let params = {
        DPId: "88800",
        ReqId: "20478646",
        Version: "1.2",
        TransDtls:
          "zUi1cFSMvnMUG2qaHkvfSpWOAvBb+61ioARzb3igCQ+g8PTHD65VaTqwGgao6kPP+hqFAsXq9WYt/fG7GMpneRWjP8GjinC5ywNKcx+aNU9SR9BHrhySaIwEYqk5ExSHVvHozXvqDL8TsXA+g9gd6tNaKlS5/7DbmBbxlvkCeVU08RyWCXF7KZFOu8finlZkzrHLYeMpTi8dxUFpylK3qWkSnUM6cTWdAsecyv1HqjKR2dU1bnfT9pRLF1yv9MsJhNWKMkOyj3jQmZf2bJfJj/a8Cf140xRx4mUxYQ3qs4ZfkrKlzy4c6E1qZ83+dwOC1Ign6cH0lK6mSuGIR4bJkfqW3fY7fmsB+YhV+Zmb0Ec9zTcuBlt8YMnFbKYVrDcpBmmqw0sQl3lclW113wbzsSMlzwMwdH4XgH+snyNXC/pQljq/We0CF0EOPl8ugUFaGY00huvL4fsRnX4oPbzjHQ==",
      };

      for (var p in params) {
        let input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", p);
        input.setAttribute("value", params[p]);
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },
   sellStockChoice(order) {
      var BOID = this.userProfile.extra_info.choice.boid;
      serverAddr
        .post("/trade/v1/verify_edis", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
          user_id: this.userProfile.username,
          boid: BOID,
          exchange: order.exchange,
          edis_stocks: [
            {
              ISIN: order.isin,
              Quantity: order.quantity,
              Symbol: order.symbol,
            },
          ],
        })
        // .then((async(response)) => {
        .then(async (response) => {
          if (response.data.status) {
            this.edisStatusCheck(response.data.data.Response);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    edisStatusCheck(data) {
      serverAddr
        .post("/trade/v1/edis_status_check", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
          edis_request_id: data.ReqId,
        })
        // .then((async(response)) => {
        .then(async (response) => {
          if (response.data.status) {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sellStock(order) {
      // commited selected order id and set active sub menu to trade
      this.$store.commit("commitOrderId", order.id);
      this.$store.commit("commitTradeMenu", "TRADE");
      this.$store.commit("commitSelectedOrder", order);
      this.$store.commit("commitSelectedOrderType", "SELL");
    },
    getUserDetails() {
      serverAddr
        .post("/auth/v1/broker/user/detail", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
        })
        .then(async (response) => {
          if (response.data.status) {
            this.fetchUserDetails = response.data.data;
            this.sell_holding_dialog_visibility = true;

          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getHoldingsNetWorkCallBack() {
      this.loading = true; //displayed loader

      serverAddr
        .post("/trade/v1/holding", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
        })
        .then((response) => {
          if (response.data.status) {
            this.holdings = response.data.data;
          } else {
            this.holdings = [];
          }

          this.loading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.loading = false; //hide loader
          this.holdings = [];
        });
    },

    sendTPIN(order) {
      this.loading = true; //displayed loader

      serverAddr
        .post("/trade/v1/generate_tpin", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
        })
        .then(async (response) => {
          if (response.data.status) {
            let html_res = await this.getHTMLForm(order);

            if (html_res.data.status) {
              this.raw_html = JSON.parse(
                JSON.stringify(html_res.data.data.edisFormHtml)
              );

              this.get_tpin_dialog_visibility = true;

              setTimeout(() => {
                let form = document.getElementsByTagName("form")[0];
                form.setAttribute("target", "_blank");
                document.getElementById("submitbtn").click();

                this.get_tpin_dialog_visibility = false;
              }, 500);
            }
          } else {
          }

          this.loading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.loading = false; //hide loader
        });
    },

    getHTMLForm(order) {
      return serverAddr
        .post("/trade/v1/generate_tpin_form", {
          broker_id: localStorage.getItem("selected_broker")
            ? Number(localStorage.getItem("selected_broker"))
            : "",
          isin: order.isin,
          quantity: 1,
          exchange: "NSE",
          segment: "EQ",
          bulk: false,
        })
        .then(async (response) => {
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    closeTpinDialog() {
      this.get_tpin_dialog_visibility = false;
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    getHoldings() {
      return this.holdings;
    },
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.Holdings {
  table {

    th,
    td {
      width: 120px;
    }
  }

  .custom-tooltip {
    .tooltip {
      position: relative;
      display: inline-block;
      // border-bottom: 1px dotted black;
    }

    .tooltip .tooltiptext {
      font-size: 10px;
      visibility: visible;
      width: 150px;
      // background-color: #555;
      color: #000;
      border: 1px solid;
      text-align: center;
      border-radius: 6px;
      padding: 5px 0;
      position: absolute;
      z-index: 1;
      bottom: 125%;
      left: 50%;
      margin-left: -60px;
      opacity: 0;
      transition: opacity 0.3s;
    }

    .tooltip .tooltiptext::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #555 transparent transparent transparent;
    }

    .tooltip:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
  }

  .box-card {
    box-shadow: none;
    border-radius: 10px;
  }

  .sub-title {
    font-size: 0.8rem;
    color: $label-color;
  }

  .proceedBtn {
    border: 1px solid;
    background-color: #ffff;
    color: #2d2e8d;
    padding: 6px;
    width: 80px;
    border-radius: 15px;
  }

  .el-icon-refresh {
    cursor: pointer;
    font-size: 22px;
  }

  .el-icon-refresh:hover {
    color: #2488fe;
  }
}
</style>
